import { CSSProperties } from "react";

import { ExternalAppConfig } from "../bills/Bills.types";

export enum BillType {
  AutoPay = "AUTO_PAY",
  PayOnce = "PAY_ONCE",
}

export enum CurrencyCode {
  Usd = "USD",
  Cad = "CAD",
}

export enum BillCategory {
  Hdc1Dot0 = "HDC1DOT0",
  Hdc1Dot5 = "HDC1DOT5",
  Insurance = "INSURANCE",
}

export enum BillStatus {
  Failed = "FAILED",
  Ok = "OK",
  PastDue = "PAST_DUE",
}

type AlignedProductDetails = {
  category: BillCategory;
  productNumber?: string | null | undefined;
  // amount: number;
  formattedAmount: string;
  productDetails: Array<string>;
};

type VehicleKeyVal = {
  key: string;
  value: string;
};

type RevalVehicleDetails = {
  currentValue: string;
  id: string;
  make?: VehicleKeyVal | null;
  model?: VehicleKeyVal | null;
  newValue: string;
  year: string;
};

export type ApiBill = {
  id: string;
  type: BillType;
  category: BillCategory;
  productNumber?: string | null | undefined;
  formattedProductNumber?: string | null | undefined;
  // The last two digits are the two decimal places (e.g. $1.00 is represented as 100)
  amount: number;
  formattedAmount: string;
  // If product is HDC, and no next payment date, that means user buys it for the first time
  nextPaymentDate?: string;
  expirationDate: string;
  currency: CurrencyCode;
  paymentUrl: string;
  productDetails: string[];
  informAboutStatus: boolean;
  status: BillStatus;
  total: {
    // The last two digits are the two decimal places (e.g. $1.00 is represented as 100)
    amount: number;
    formattedAmount: string;
  };
  revalOffer?: {
    currentPremium: string;
    endoNumber: string;
    endoStatus: string;
    newPremium: string;
    policyNumber: string;
    premiumDifference: string;
    vehicleValues?: Array<RevalVehicleDetails | null | undefined> | null;
  } | null;
  autoPayMethodDetails?:
    | {
        last4: string;
      }
    | null
    | undefined;
  alignedBill?: AlignedProductDetails | null;
  // API does not return it yet
  isSubmitted?: boolean;
};

export type BillProps = {
  bill: ApiBill;
  className?: string;
  style?: CSSProperties;
  onAction?(actionType: "pay" | "details", bill: ApiBill): void;
  // It's defined when autoPayDetails is null
  onPayClick?(bill: ApiBill): void;
  // It's defined when autoPayDetails is defined
  onViewDetailsClick?(bill: ApiBill): void;
} & ExternalAppConfig;
